// Care coordination subsection form field enum
export enum CareCoordinationFormField {
  CARE_COORDINATION_PREVIOUS_APPOINTMENTS = 'medical-background/care-coordination/previous-appointments',
  CARE_COORDINATION_FUTURE_APPOINTMENTS = 'medical-background/care-coordination/future-appointments',
  CARE_COORDINATION_CARE_TEAM_COORDINATION = 'medical-background/care-coordination/care-team-coordination',
  CARE_COORDINATION_ORDERS_FOR_TREATMENT = 'medical-background/care-coordination/orders-for-treatment',
  CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION = 'medical-background/care-coordination/date-of-verbal-communication'
}
